<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="900"
    scrollable
    @keydown.esc="cancelButtonClickEvent"
    @close="cancelButtonClickEvent"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>排出事業者の検索</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text style="max-height: 60vh;overflow-y: scroll;">
        <v-data-table
          :headers="tableHeaders"
          :items="disposers"
          :items-per-page="-1"
          item-key="key"
          disable-sort
          hide-default-footer
          single-select
          @click:row="rowClickEvent"
          @dblclick:row="rowDoubleClickEvent"
        >
          <template v-slot:[`item.name`]="{ item }">
            <div
              :title="item.name"
              class="ellipsis-text"
              style="max-width: 300px;width: initial;font-size: 90%;"
            >
              {{ item.name }}
            </div>
          </template>
          <template v-slot:[`item.location.name`]="{ item }">
            <div
              :title="item.location.name"
              class="ellipsis-text"
              style="max-width: 300px;width: initial;font-size: 90%;"
            >
              {{ item.location.name }}
            </div>
          </template>
        </v-data-table>
        <v-row dense>
          <v-col>
            <v-pagination
              v-model="page"
              :length="pagination.total_pages"
              :total-visible="totalVisible"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="pageChangeEvent"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancelButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!selectedItem"
          @click="registerButtonClickEvent"
        >
          反映
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";
export default {
  name: 'SearchTenantDisposerDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      panel: [],
      page: 1,
      totalVisible: 7,
      disposers: [],
      selectedItem: null,
      selectedRow: null,
      tableHeaders: [
        { text: '排出事業者', value: 'name', width: "45%" },
        { text: '排出事業場', value: 'location.name', width: "55%" },
      ],
      modes: [
        { value: "emission", text: "排出事業者" },
        { value: "emissionLocation", text: "排出事業場" },
      ],
      pagination: {
        current_page: 1,
        total_count: 0
      },
    }
  },
  computed: {},
  watch: {
    enableDialog () {
      this.panel = []
      this.emissions = []
      this.page = 1
      Object.assign(this.$data.pagination, this.$options.data().pagination)
      if (this.selectedRow) {
        this.selectedRow.select(false)
      }
      this.selectedItem = null
    },
  },
  created() {
    this.page = 1
    this.searchEmissions()
  },
  methods: {
    ...mapActions('DriverMasterSearchTenantDisposerDetail', {
      fetchEmissionDetails: 'index',
    }),
    pageChangeEvent () {
      this.searchEmissions()
    },
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    registerButtonClickEvent () {
      this.$emit('registerCallback', this.selectedItem)
    },
    /**
     * 行選択イベント
     * @param item
     * @param row
     */
    rowClickEvent (item, row) {
      this.selectedItem = item
      this.selectedRow = row
      row.select(true)
    },
    /**
     * 行反映ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("registerCallback", row.item);
    },
    searchEmissions() {
      this.fetchEmissionDetails().then((content) => {
        this.disposers = content.disposers
        this.pagination = content.pagination
      })
    }
  }
}
</script>
